"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusteringTabPanel = void 0;
const React = require("react");
const core_1 = require("@material-ui/core");
const integration_1 = require("../../projection/integration");
const react_redux_1 = require("react-redux");
const Cluster_1 = require("../../util/Cluster");
const Story_1 = require("../../util/Story");
const graphs_1 = require("../../util/graphs");
const SelectedClustersDuck_1 = require("../../Ducks/SelectedClustersDuck");
const CurrentClustersDuck_1 = require("../../Ducks/CurrentClustersDuck");
const ClusterEdgesDuck_1 = require("../../Ducks/ClusterEdgesDuck");
const DisplayModeDuck_1 = require("../../Ducks/DisplayModeDuck");
const StoriesDuck_1 = require("../../Ducks/StoriesDuck");
const Folder_1 = require("@material-ui/icons/Folder");
const Delete_1 = require("@material-ui/icons/Delete");
const mapStateToProps = (state) => ({
    currentAggregation: state.currentAggregation,
    stories: state.stories,
    currentClusters: state.currentClusters,
    displayMode: state.displayMode,
    dataset: state.dataset,
    webGLView: state.webGLView,
    selectedClusters: state.selectedClusters
});
const mapDispatchToProps = dispatch => ({
    setCurrentClusters: clusters => dispatch(CurrentClustersDuck_1.setCurrentClustersAction(clusters)),
    setStories: stories => dispatch(StoriesDuck_1.setStories(stories)),
    setActiveStory: (activeStory) => dispatch(StoriesDuck_1.setActiveStory(activeStory)),
    setClusterEdges: clusterEdges => dispatch(ClusterEdgesDuck_1.setClusterEdgesAction(clusterEdges)),
    setDisplayMode: displayMode => dispatch(DisplayModeDuck_1.setDisplayMode(displayMode)),
    setSelectedClusters: value => dispatch(SelectedClustersDuck_1.setSelectedClusters(value)),
    addCluster: cluster => dispatch(CurrentClustersDuck_1.addCluster(cluster)),
    addClusterToStory: cluster => dispatch(StoriesDuck_1.addClusterToStory(cluster)),
    removeCluster: cluster => dispatch(CurrentClustersDuck_1.removeCluster(cluster)),
    addStory: story => dispatch(StoriesDuck_1.addStory(story)),
    removeClusterFromStories: cluster => dispatch(StoriesDuck_1.removeClusterFromStories(cluster))
});
const connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
exports.ClusteringTabPanel = connector(({ setCurrentClusters, setStories, setActiveStory, currentAggregation, clusteringWorker, dataset, stories, setClusterEdges, currentClusters, setDisplayMode, displayMode, setSelectedClusters, addCluster, removeCluster, addStory, addClusterToStory, removeClusterFromStories, webGLView, selectedClusters }) => {
    function storyLayout(edges) {
        var stories = [];
        var copy = edges.slice(0);
        // hh
        while (copy.length > 0) {
            var toProcess = [copy.splice(0, 1)[0]];
            var clusters = new Set();
            var storyEdges = new Set();
            while (toProcess.length > 0) {
                var edge = toProcess.splice(0, 1)[0];
                do {
                    clusters.add(edge.source);
                    clusters.add(edge.destination);
                    storyEdges.add(edge);
                    var idx = copy.findIndex(value => value.destination == edge.source || value.source == edge.destination);
                    if (idx >= 0) {
                        var removed = copy.splice(idx, 1)[0];
                        clusters.add(removed.source);
                        clusters.add(removed.destination);
                        storyEdges.add(removed);
                        toProcess.push(removed);
                    }
                } while (idx >= 0);
            }
            stories.push(new Story_1.Story([...clusters], [...storyEdges]));
        }
        return stories;
    }
    function toggleClusters() {
        if (currentClusters == null) {
            if (dataset.clusters && dataset.clusters.length > 0) {
                let clusters = dataset.clusters;
                setCurrentClusters(clusters);
                if (dataset.clusterEdges && dataset.clusterEdges.length > 0) {
                    setClusterEdges(dataset.clusterEdges);
                    let stories = storyLayout(dataset.clusterEdges);
                    setStories(stories);
                    //setActiveStory(stories[0])
                }
                else {
                    if (dataset.isSequential) {
                        const [edges] = graphs_1.graphLayout(clusters);
                        setClusterEdges(edges);
                        if (edges.length > 0) {
                            let stories = storyLayout(edges);
                            setStories(stories);
                            //setActiveStory(stories[0])
                        }
                    }
                }
            }
            else {
                let worker = new Worker('dist/cluster.js');
                worker.onmessage = (e) => {
                    // Point clusteruing
                    let clusters = [];
                    Object.keys(e.data).forEach(k => {
                        let t = e.data[k];
                        let f = new Cluster_1.default(t.points, t.bounds, t.hull, t.triangulation);
                        f.label = k;
                        clusters.push(f);
                    });
                    // Inject cluster attributes
                    clusters.forEach(cluster => {
                        let vecs = [];
                        cluster.points.forEach(point => {
                            vecs.push(dataset.vectors[point.meshIndex]);
                        });
                        cluster.vectors = vecs;
                        cluster.points = cluster.vectors;
                    });
                    setCurrentClusters(clusters);
                    if (dataset.clusterEdges && dataset.clusterEdges.length > 0) {
                        setClusterEdges(dataset.clusterEdges);
                        let stories = storyLayout(dataset.clusterEdges);
                        setStories(stories);
                        //setActiveStory(stories[0])
                    }
                    else {
                        if (dataset.isSequential) {
                            const [edges] = graphs_1.graphLayout(clusters);
                            setClusterEdges(edges);
                            if (edges.length > 0) {
                                let stories = storyLayout(edges);
                                setStories(stories);
                                //setActiveStory(stories[0])
                            }
                        }
                    }
                };
                worker.postMessage({
                    type: 'extract',
                    message: dataset.vectors.map(vector => [vector.x, vector.y, vector.clusterLabel])
                });
            }
        }
        else {
            setStories(stories);
            setActiveStory(null);
            setCurrentClusters(null);
            setSelectedClusters([]);
        }
    }
    React.useEffect(() => toggleClusters(), [dataset]);
    return React.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%' } },
        React.createElement(core_1.Box, { p: 2 },
            React.createElement(core_1.FormControlLabel, { control: React.createElement(core_1.Switch, { checked: displayMode == DisplayModeDuck_1.DisplayMode.OnlyClusters, onChange: (event) => {
                        setDisplayMode(event.target.checked ? DisplayModeDuck_1.DisplayMode.OnlyClusters : DisplayModeDuck_1.DisplayMode.StatesAndClusters);
                    }, name: "test" }), label: "Show Clusters Only" })),
        React.createElement(integration_1.ClusterWindow, { worker: clusteringWorker, onClose: () => {
                var worker = clusteringWorker;
                if (worker != null) {
                    worker.terminate();
                }
                this.setState({
                    clusteringWorker: null,
                    clusteringOpen: false
                });
            } }),
        React.createElement(core_1.Box, { p: 2 },
            React.createElement(core_1.Typography, { variant: "h6" }, "Clusters")),
        React.createElement(core_1.Box, { paddingLeft: 2, paddingRight: 2 },
            React.createElement(core_1.Button, { variant: "outlined", style: {
                    width: '100%'
                }, onClick: () => {
                    if (currentAggregation.length > 0) {
                        let cluster = Cluster_1.default.fromSamples(currentAggregation);
                        addCluster(cluster);
                        if (!stories.active) {
                            let story = new Story_1.Story([cluster], []);
                            addStory(story);
                            setActiveStory(story);
                        }
                        else {
                            addClusterToStory(cluster);
                        }
                    }
                } }, "Add From Selection")),
        React.createElement("div", { style: { overflowY: 'auto', height: '100px', flex: '1 1 auto' } },
            React.createElement(core_1.List, null, currentClusters === null || currentClusters === void 0 ? void 0 : currentClusters.map((cluster, key) => {
                return React.createElement(core_1.ListItem, { key: key, button: true, selected: selectedClusters.includes(cluster), onClick: () => {
                        webGLView.current.onClusterClicked(cluster);
                    } },
                    React.createElement(core_1.ListItemAvatar, null,
                        React.createElement(core_1.Avatar, null,
                            React.createElement(Folder_1.default, null))),
                    React.createElement(core_1.ListItemText, { primary: `Cluster ${cluster.label}`, secondary: `${cluster.vectors.length} Samples` }),
                    React.createElement(core_1.ListItemSecondaryAction, null,
                        React.createElement(core_1.IconButton, { edge: "end", "aria-label": "delete", onClick: () => {
                                removeClusterFromStories(cluster);
                                removeCluster(cluster);
                            } },
                            React.createElement(Delete_1.default, null))));
            }))));
});
